<template>
<div class="d-flex align-center">
    <div class="mr-1">{{ reporte.premio | currency(reporte.divisa_code) }}</div>
    <div v-if="reporte.comparison?.premio" class="d-flex text-caption" :class="{
        'error--text': reporte.comparison.premio[1] >= 0,
        'accent--text': reporte.comparison.premio[1] < 0,
    }">
        <div class="ml-1">{{ reporte.comparison.premio[0] | percent }}</div>
        <v-icon v-if="reporte.comparison.premio[1] >= 0" color="error" small>mdi-trending-up</v-icon>
        <v-icon v-else color="accent" small>mdi-trending-down</v-icon>
    </div>
</div>
</template>
<script>

export default {
    props: {
        reporte: {
            required: true
        }
    }
}
</script>